<template>
  <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b">
    <el-menu-item index="/supermam/eventTrack">推广日志</el-menu-item>
    <el-menu-item disabled="" index="/supermam/eventBoard">未开封</el-menu-item>
    <el-submenu index="longinOutOption" style="float: right">
      <template slot="title">{{ loginName }}</template>
      <el-menu-item index="longinOut" style="text-align: center">退出</el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "NavMenu",
  data() {
    return {
      loginName: localStorage.getItem('username'),
      activeIndex: '/supermam/eventTrack',
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      if (key === 'longinOut') {
        Cookies.remove('mam-token')
        this.$router.push('/supermam/login')
        return
      }
      if (key !== this.$route.path) {
        this.$router.push(key)
      }
    },
  }
}
</script>
<style scoped>

</style>
